import SymbolNotam from '@/presentation/assets/airspaceSymbols/symbol-notam.png'

export const notamHighlightColor = '#F04747'

export const notamImage = SymbolNotam
